import { combineReducers } from "redux";
import auth from "./auth/reducer";
import app from "./app/reducer";
import user from "./user/reducer";
export default combineReducers({
  auth,
  app,
  user,
});
